import React, { useState, useCallback } from 'react'
import { Breadcrumbs, Grid, Link } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { SwitchPeriod } from './SwitchPeriod'
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks'
import { PrimaryButton } from '../../../ui/Button'
import { EnvName, EnvType, KaryonModules, UsersRole, UsersStatus } from '../../../../redux/user/userTypes'
import { ViewConfig, ViewsSteps } from '../../../../redux/views/viewsTypes'
import { setupCampaign } from '../../../../redux/views/viewsSlice'
import { PagesName } from '../../navigation/types/pages'
import { WHITE } from '../../../ui/Colors'
import { PagesTitle, PrimaryText, } from '../../../ui/Text'
import { resetDashboard } from '../../../../redux/global/globalSlice'
import { resetActiveFsFilters, resetFSFilters } from '../../../../redux/filters/filtersSlice'
import { useNavigate } from 'react-router-dom'
import { NotificationsDrawer } from '../../notification/NotificationsDrawer'
import { NotificationsInHeader } from '../../notification/NotificationsInHeader'
import { SupportInHeader } from '../../support/SupportInHeader'
import { SupportDrawer } from '../../support/SupportDrawer'

const BasicBreadcrumbs = ({ title }: { title: string }) => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const resetRedux = useCallback(() => {
        dispatch(resetDashboard())
        dispatch(resetFSFilters())
        dispatch(resetActiveFsFilters())
    }, [dispatch])


    const handleClick = () => {
        localStorage.setItem("multiAccountCompanyId", null);
        resetRedux()
        navigate(`/multiAccount`)
    }

    return (
        <Breadcrumbs>
            <Link
                underline="hover"
                color="inherit"
                onClick={handleClick}
            ><PagesTitle
                ml="1vw"
            >
                    Page d'accueil
                </PagesTitle>
            </Link>
            {title && <PagesTitle
                ml="1vw"
            >
                {title}
            </PagesTitle>}
        </Breadcrumbs>

    );
}

const PrivateHeader = ({
    title,
    attribute,
    period,
    onViewPage,
    page
}: {
    title: string
    attribute?: number
    period?: boolean
    hasOtherUnitAvailable?: boolean
    onViewPage?: boolean
    page?: PagesName
}) => {
    const dispatch = useAppDispatch()
    const { role, status, modules } = useAppSelector((state) => state.user.user)
    const { env } = useAppSelector((state) => state.global)
    /* FOR SWITCH UNIT
    const dispatch = useAppDispatch()
    const _setUnit = useCallback(
        (unit: units) => dispatch(setUnit(unit)),
        [dispatch]
    )
    const { unit } = useAppSelector((state) => state.global)
 
    const handleChangeUnitButton = () => {
        if (unit === Units.kg) {
            _setUnit(Units.uvc)
        }
        if (unit === Units.uvc) {
            _setUnit(Units.kg)
        }
    } */

    /* **CAMPAIGNS** */

    const _setupCampaign = useCallback(
        (viewConfig: ViewConfig) =>
            dispatch(setupCampaign({ config: viewConfig })),
        [dispatch]
    )

    const handleCampaignClick = () => {
        _setupCampaign({
            steps: [ViewsSteps.CampaignFS]
        })
    }

    /* **NOTIFICATIONS** */
    const [openNotificationsDrawer, setOpenNotificationsDrawer] = useState(false)
    const { notifications } = useAppSelector((state) => state.notifications)

    const notificationsNotArchived =
        notifications &&
        notifications.filter((el) => el.isArchived === false)

    /* **SUPPORT** */
    const [openSupportDrawer, setOpenSupportDrawer] = useState(false)


    return (
        // <Grid>
        //     <Alert severity="error"> Nous avons détecté des latences sur le chargement de la plateforme, nos équipes en train d'investiguer. Vous pouvez filtrer vos requêtes afin d'optimiser le temps de chargement.
        //         Nous nous excusons d'avance pour la potentielle gêne occasionnée.</Alert>
        <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            position="sticky"
            direction="row"
        >
            <Grid container alignItems="center" direction="row" width="auto" flexWrap="nowrap">
                {(role === UsersRole.SUPER_ADMIN) ?
                    (<BasicBreadcrumbs title={title} />) : (<PagesTitle
                        ml="1vw" >
                        {title}
                    </PagesTitle>)}
                {attribute ? (
                    <PagesTitle
                        ml={1}
                    >
                        ({attribute})
                    </PagesTitle>
                ) : null}
                {period && <SwitchPeriod onViewPage={onViewPage} />}
            </Grid>
            <Grid container justifyContent="flex-end" alignItems="center" mr="1vw" width="40%">
                {(page === PagesName.PROMO || page === PagesName.CAMPAIGN) &&
                    <Grid container alignItems="center" mr="1vw" height="90%" width="auto">
                        <PrimaryButton id="openNotifications" onClick={handleCampaignClick}>
                            <AddIcon sx={{
                                color: WHITE,
                                width: { xs: '22px', md: '2.5vw' },
                                height: { xs: '22px', md: '2.5vh' },
                            }} />
                            <PrimaryText color={WHITE} textTransform="none">Ajouter une campagne</PrimaryText>
                        </PrimaryButton>
                    </Grid>}

                {status !== UsersStatus.STANDALONE &&
                    modules.includes(KaryonModules.NOTIFICATIONS) &&
                    env.type !== EnvType.RETAIl && env.name === EnvName.FRANCE_FRAIS && (
                        <NotificationsInHeader
                            setOpen={setOpenNotificationsDrawer}
                            numberOfNotifications={
                                notificationsNotArchived &&
                                notificationsNotArchived.length
                            }
                        />
                    )}
                <SupportInHeader setOpen={setOpenSupportDrawer} />
                <NotificationsDrawer open={openNotificationsDrawer} setOpen={setOpenNotificationsDrawer} />
                <SupportDrawer open={openSupportDrawer} setOpen={setOpenSupportDrawer} />

            </Grid>
        </Grid>
    )
}

export default PrivateHeader
